import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import baseUrl from "../../API/BaseUrl";

const initialState = {
  allProducts: [],
  SearchProducts: [],
  FashionProduct : [],
  ToysProduct : [],
  ProductsOnCategoryList : [],
  productDetails: {},
  LikeProducts: [],
  DeleteProduct: [],
  editProduct: [],
  isLoading: true,
  isSuccess: true,
  errorMessage: "",
};

// add new products
export const addNewProduct = createAsyncThunk(
  "newProduct/addNew",
  async (formData) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await baseUrl.post("/api/v1/products", formData, config);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// get all products
export const getAllProducts = createAsyncThunk(
  "Allproducts/getAll",
  async (querySelector) => {
    try {
      const res = await baseUrl.get(`api/v1/products?${querySelector}`);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// get products on category
export const getFashionProducts = createAsyncThunk(
  "getAll/FashionPrdouct",
  async (CatId) => {
    try {
      const res = await baseUrl.get(`/api/v1/products?category=${CatId}`);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// get products on category
export const getToysProducts = createAsyncThunk(
  "getAll/ToysPrdouct",
  async (CatId) => {
    try {
      const res = await baseUrl.get(`/api/v1/products?category=${CatId}`);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// get products on category
export const getProductsOnCategory = createAsyncThunk(
  "getAll/PrdouctsOnCategory",
  async ({CatId,limit,page}) => {
    try {
      const res = await baseUrl.get(`/api/v1/products?category=${CatId}&limit=${limit}&page=${page}`);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// get  product details
export const getProductDetails = createAsyncThunk(
  "productDetails",
  async (id) => {
    try {
      const res = await baseUrl.get(`/api/v1/products/${id}`);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// delete one product
export const DeleteOneProduct = createAsyncThunk(
  "oneProduct/delete",
  async (id) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await baseUrl.delete(`/api/v1/products/${id}`, config);
      return res;
    } catch (error) {
      return error;
    }
  }
);

// edit product
export const EditProduct = createAsyncThunk("productOne/editProduct", async ({id, data}) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
    }
    const res = await baseUrl.put(`/api/v1/products/${id}`,data,config)
    return res
  } catch (error) {
    return error
  }
})

// search products
export const ProductsSearch = createAsyncThunk("getproduct/searchProducts", async (querySelector) => {
  try {
    const res = await baseUrl.get(`/api/v1/products?${querySelector}`)
    return res
  } catch (error) {
    return error
  }
})

const ProductSlice = createSlice({
  name: "product",
  initialState,
  reducers: {},
  extraReducers: {
    [addNewProduct.pending]: (state, action) => {
      state.isLoading = true;
    },
    [addNewProduct.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.allProducts = action.payload;
    },
    [addNewProduct.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [getAllProducts.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getAllProducts.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.allProducts = action.payload;
    },
    [getAllProducts.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [getProductDetails.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getProductDetails.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.productDetails = action.payload;
    },
    [getProductDetails.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [getProductsOnCategory.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getProductsOnCategory.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.ProductsOnCategoryList = action.payload;
    },
    [getProductsOnCategory.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [getFashionProducts.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getFashionProducts.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.FashionProduct = action.payload;
    },
    [getFashionProducts.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [getToysProducts.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getToysProducts.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.ToysProduct = action.payload;
    },
    [getToysProducts.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [DeleteOneProduct.pending]: (state, action) => {
      state.isLoading = true;
    },
    [DeleteOneProduct.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.DeleteProduct = action.payload;
    },
    [DeleteOneProduct.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [EditProduct.pending]: (state, action) => {
      state.isLoading = true;
    },
    [EditProduct.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.editProduct = action.payload;
    },
    [EditProduct.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [ProductsSearch.pending]: (state, action) => {
      state.isLoading = true;
    },
    [ProductsSearch.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.SearchProducts = action.payload;
    },
    [ProductsSearch.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
  },
});

export default ProductSlice.reducer;
